import { Component, inject } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme.service';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    standalone: false
})
export class ForbiddenComponent {
    private readonly themeService = inject(ThemeService);

    public theme$ = this.themeService.themeChanges;
}
